export default {
  "projectOrder.title": "Add Standard Products",
  "projectOrder.explain":
    "Note: For the wardrobe products please comfirm the grouping before adding, otherwise the grouping/ungrouping operation may lead to the loss of data.",
  "projectOrder.showCaxa": "Display the standard design or not:",
  "projectOrder.caseName": "Name of Project",
  "projectOrder.product": "Combined Cabinet",
  "projectOrder.productDetail": "Details of Standard Products",
  "projectOrder.operate": "Operation",
  "projectOrder.open": "Yes",
  "projectOrder.close": "No",
  "projectOrder.packageType": "Package Type",
  "projectOrder.specifications": "Specifications",
  "projectOrder.productCode": "Product Code",
  "projectOrder.model": "Model",
  "projectOrder.classify": "Classify",
  "projectOrder.details": "Details",
  "projectOrder.order": "(Place an order)",
  "projectOrder.notOrder": "(Do not place orders)",
  "projectOrder.edit": "Edit",
  "projectOrder.designScheme": "(Design Scheme)",
  "projectOrder.parameters": "Order parameters",
  "projectOrder.FaucetModel": "Faucet model",
  "projectOrder.nonStandard": "Is it non-standard",
  "projectOrder.installingBasin": "Method for installing basin",
  "projectOrder.informationCenter":
    "This page is provided by OPPEIN Group Marketing Information Center",
  "projectOrder.createServiceOrder": "Create a service order form",
  "projectOrder.rebind": "Rebind",
  "projectOrder.fold": "Fold",
  "projectOrder.unfold": "Unfold",
  "projectOrder.foldUnfold": "Unfold/Fold",
  "projectOrder.more": "More",
  "projectOrder.relatedOrder": "Related order application",
  "projectOrder.orderApplication": "Order application number",
  "projectOrder.projectName": "Project name",
  "projectOrder.projectBatch": "Project batch information",
  "projectOrder.contractNumber": "Contract number",
  "projectOrder.buildingName": "Building name",
  "projectOrder.brand": "Brand",
  "projectOrder.category": "Category",
  "projectOrder.totalNumberSets": "Total number of sets",
  "projectOrder.serviceOrderNumber": "Service order number",
  "projectOrder.orderStatus": "Service order status",
  "projectOrder.orderState": "Order state",
  "projectOrder.houseType": "House type",
  "projectOrder.schemeNumber": "Scheme number",
  "projectOrder.creationTime": "Creation time",
  "projectOrder.supplementaryOrder": "Supplementary order",
  "projectOrder.details": "Details",
  "projectOrder.orderCategory": "Order category",
  "projectOrder.designer": "Designer",
  "projectOrder.designerPhone": "Designer phone",
  "projectOrder.draftsman": "Draftsman",
  "projectOrder.draftsmanPhone": "Draftsman's phone",
  "projectOrder.expectedDeliveryTime": "Expected delivery time",
  "projectOrder.createStandards": "Create standards separately",
  "projectOrder.myOrderTask": "My order task",
  "projectOrder.customerInfo": "Customer Info",
  "projectOrder.serviceOrder": "Service order",
  "projectOrder.productsOrdered": "Products ordered",
  "projectOrder.orderInfos": "Order info",
  "projectOrder.orderInfo": "Order info",
  "projectOrder.attachments": "Attachments",
  "projectOrder.detailsExpress": "Details",
  "projectOrder.sceneFiles": "Scene files",
  "projectOrder.spaceProductName": "Space product name",
  "projectOrder.afterSalesOrder": "After-sales order",
  "projectOrder.productChannels": "Product channels",
  "projectOrder.standardProducts": "Standard  products",
  "projectOrder.placeAnOrder": "Place an order",
  "projectOrder.doNotPlaceAnOrder": "Do not place orders",
  "projectOrder.design": "Design",
  "projectOrder.specs": "Specs",
  "projectOrder.model": "Model",
  "projectOrder.code": "Code",
  "projectOrder.productType": "Product type",
  "projectOrder.details": "Details",
  "projectOrder.addStandardProducts": "Add standard products",
  "projectOrder.serviceOrderNumber": "Service order number",
  "projectOrder.noServiceOrderNumber": "No service order number",
  "projectOrder.orderName": "Order name",
  "projectOrder.orderConsistent": "Is the entire order consistent",
  "projectOrder.productCategory": "Product category",
  "projectOrder.designSource": "Design source",
  "projectOrder.approvalForm": "With approval form or not",
  "projectOrder.assembled": "Assembled or not",
  "projectOrder.markType": "Mark type",
  "projectOrder.assemblyMethod": "Product assembly method",
  "projectOrder.cartonRequirements": "Carton requirements",
  "projectOrder.logisticsMethods": "Logistics methods",
  "projectOrder.displayRequirements": "Sample display requirements",
  "projectOrder.installationMethod": "Installation method of basin",
  "projectOrder.customerSupplied": "Non-factory products need to be matched",
  "projectOrder.projectInfo": "Project info",
  "projectOrder.batchOrderQuantity": "Batch order quantity",
  "projectOrder.remarks": "Remarks",
  "projectOrder.variableTable": "Variable table",
  "projectOrder.view": "View",
  "projectOrder.setup": "Set up",
  "projectOrder.orderQuantity": "Order quantity",
  "projectOrder.orderableQuantity": "Orderable quantity",
  "projectOrder.ordersPlacedNunmber": "Number of orders placed this time",
  "projectOrder.upload": "Upload",
  "projectOrder.splittingOrders": "Instructions for splitting orders",
  "projectOrder.splitOrderSuccessful": "Split order Successful",
  "projectOrder.splitOrderFailed": "Split order failed",
  "projectOrder.initiateInspection": "Initiate inspection",
  "projectOrder.oneClickOrder": "One-click order",
  "projectOrder.refreshOrder": "Refresh order progress",
  "projectOrder.relatedOrderApplication": "Related order application",
  "projectOrder.buildingAbbreviation": "Building abbreviation",
  "projectOrder.orderApplicationNo": "Order application number",
  "projectOrder.numberOfSetsOrdered": "Number of sets ordered",
  "projectOrder.search": "Search",
  "projectOrder.addServiceOrder": "Add service order",
  "projectOrder.option": "Option",
  "projectOrder.houseType": "House type",
  "projectOrder.schemeNo": "Scheme No.",
  "projectOrder.orderQuantitys": "Order quantity",
  "projectOrder.engineerServiceOrder": "Service Order",
  "projectOrder.batchSettings": "Batch Settings",
  "projectOrder.brandCategory": "Brand category",
  "projectOrder.orderType": "Order type",
  "projectOrder.EngineeringServiceNumber": "Service order number",
  "projectOrder.splitOrderDetails": "Instructions for splitting orders",
  "projectOrder.initiateSplitOrder": "Initiate split order",
  "projectOrder.serialNumber": "Serial Number",
  "projectOrder.placeOrderOrNot": "Place an order or not",
  "projectOrder.customerName": "Customer Name",
  "projectOrder.associateBefore":
    "Please associate the order application before placing the order",
  "projectOrder.selectSceneFirst": "Please select a scene file first",
  "projectOrder.faucetCode": "Faucet Code",
  "projectOrder.deliveryTomorrow":
    "The expected delivery date needs to be selected after tomorrow",
  "projectOrder.basinInstallation":
    "The installation method of the water basin cannot be empty",
  "projectOrder.assembleEmpty": "Whether to assemble can not be empty",
  "projectOrder.quantityEmpty":
    "The quantity of the batch order cannot be empty",
  "projectOrder.nonStandardApproval":
    "Please select non-standard approval form",
  "projectOrder.serviceOrderIdEmpty":
    "Service order id cannot be empty, please select another service order",
  "projectOrder.quantityOrderEmpty": "The quantity of this order cannot be 0",
  "projectOrder.brandCategoryConsistent":
    "The brand and category of the combined cabinet must be consistent with the service order",
  "projectOrder.contractNumberInvalid":
    "The selected service order contract number is invalid, please replace the service order",
  "projectOrder.requiresSettingVariables":
    "Non whole order consistency requires setting variables",

  "projectOrder.sourceEmpty": "The design source cannot be empty",
  "projectOrder.variableEmpty":
    "The variable has not been set and needs to be associated with a consistent service order for the entire order. Please check if the variable or service order is correct",
  "projectOrder.variableNotEmpty":
    "The variable has been set and needs to be associated with a service order that is not consistent with the entire order. Please check if the variable or service order is correct",
  "projectOrder.categoryEmpty": "The product category cannot be empty",
  "projectOrder.expectedDeliveryEmpty":
    "The expected delivery date cannot be empty",
  "projectOrder.spaceProductsEmpty": "Space products cannot be empty",
  "projectOrder.associatedOrderEmpty":
    "The associated project service order cannot be empty.",
  "projectOrder.markTypeEmpty": "The mark type cannot be empty",
  "projectOrder.assemblyEmpty": "The product assembly method cannot be empty",
  "projectOrder.cartonEmpty": "The requirements of the carton cannot be empty",
  "projectOrder.LogisticsProcessEmpty": "Logistics process can not be empty",
  "projectOrder.sampleDisplayEmpty":
    "The Sample display requirements cannot be empty.",
  "projectOrder.customerSuppliesEmpty": "Customer supplies can not be empty",
  "projectOrder.selectedItemN":
    "The order quantity cannot be 0, please  set whether to place an order in the variable setting",
  "projectOrder.pleaseCheck": "Please check the order details",
  "projectOrder.orderIsRepeated":
    "The associated project service order is repeated, please modify the associated project service order to place an order!",
  "projectOrder.contractSelfNumber":
    "The contract self-number of the associated engineering service order is repeated, please revise it and place an order again.",
  "projectOrder.sceneContentChanged":
    "Scene content has changed, please confirm the order information",
  "projectOrder.retailOrdersSinks":
    "Retail orders for sinks cannot be placed with a single basin, please choose sets of basins to place orders",
  "projectOrder.attachmentsModified":
    "Attachments cannot be modified after placing an order.",
  "projectOrder.splitOrderNotCompleted":
    "Split order not completed, unable to continue placing order",
  "projectOrder.newInspection":
    "Please initiate a new inspection and order splitting!",
  "projectOrder.caxaCounterTop":
    "Please fill in the reason for not using CAXA countertop drawings",
  "projectOrder.illegalCharacters1":
    "The file name of the uploaded attachment contains illegal characters.",
  "projectOrder.illegalCharacters2":
    "Please correct the file name and upload again",
  "projectOrder.notAllowXml":
    "One-click order does not allow users to upload xml files",
  "projectOrder.notAllowCountertop":
    'The name of the currently uploaded file contains the word "countertop". If you want to upload a countertop file, please choose the "countertop attachment" type to upload (the bathroom countertop image is generated through CAXA and self uploading is not allowed)',
  "projectOrder.notCloseDesignFile":
    "The design software is in the process of splitting the order. Please do not close the design file. Please wait,Already used  ",
  "projectOrder.individualStandard":
    "Individual standard product orders do not need to split orders, can be placed directly",
  "projectOrder.successfullySubmitted":
    "Successfully submitted the split order, you can stay on the current page to refresh the progress of the split order, or close the current page to view the progress in the order task",
  "projectOrder.taskAlreadyHas":
    "The current order task already has a split order task. This operation will generate a new order task. Please confirm whether to continue",
  "projectOrder.orderNotDetected":
    "The project service order has not detected the relevant contract self-number, please re-select a valid project service order",
  "projectOrder.sceneNotVariables":
    "Scene file does not set variables, or abnormal data return please check! ",
  "projectOrder.serviceOrderAgain1":
    "The service order cannot be placed because the contract number of the after-sales order is not found. Please select the service order again.",
  "projectOrder.serviceOrderAgain2":
    "The service order cannot be placed because the contract number of the order is not found. Please select the service order again.",
  "projectOrder.canBePlaced":
    'Service order can only be placed under the status of "No order "," Successful order "," failed order "," Design document processing "," Design document processing succeeded "," Design document processing failed"',
  "projectOrder.readingScene": "Reading scene file content",
  "projectOrder.batchDownload": "Batch download of split order files",
  "projectOrder.hasBeenSubmitted":
    "The order task has been submitted. Please refer to 'My Order Tasks' for specific order results.",
  "projectOrder.selectedItem": "Selected item ",
  "projectOrder.and": "and",
  "projectOrder.name": "Name",
  "projectOrder.accountNumber": "Account number",
  "projectOrder.orderApplications": "Please select an order application",
  "projectOrder.applicationInvalid":
    "The selected order application is invalid/does not have a service order number",
  "projectOrder.applicationRelated":
    "Complete the application for placing an order related to the project application for placing an order",
  "projectOrder.non-standardMaterials":
    "When approving non-standard materials, please select non-standard materials for the product category",
  "projectOrder.countertopAttachment":
    'Note: If you need to upload tabletop related attachments, please choose the "Countertop Attachment" type to upload',
  "projectOrder.notAllowedCad":
    "Starting from July 10th, CAD orders are not allowed for cabinet project countertops. If you have any questions, please consult the Q&A platform",
  "projectOrder.enterContractNumber": "Please enter the contract self number",
  "projectOrder.variableSettings": "Variable settings",
  "projectOrder.importVariable": "Import Variable Table",
  "projectOrder.exportVariable": "Export Variable Table",
  "projectOrder.orderOrNot": "Place an order or not",
  "projectOrder.clearVariable": "Clear the current variable value",
  "projectOrder.reuseVariable": "Reuse historical variable values",
  "projectOrder.viewingVariable": "Viewing Historical Variable Values",
  "projectOrder.resetVariable": "Please reset the variables",
  "projectOrder.displayOrderInformation":
    "Display order information after associated order application",
  "projectOrder.pleaseSelect": "Please select",
  "projectOrder.personnelList": "Personnel List",
  "projectOrder.nameJobMobile": "Name/Job ID/Mobile Number",
  "projectOrder.option": "option",
  "projectOrder.departmentStore": "Department/Store",
  "projectOrder.post": "post",
  "projectOrder.resignationOrNot": "Resignation or not",
  "projectOrder.total": "Total",
  "projectOrder.page": "page",
  "projectOrder.goTo": "go to",
  "projectOrder.confirm": "confirm",
  "projectOrder.searchContract":
    "Search for contract self number and order number",
  "projectOrder.batchOrderPlacement": "Batch order placement",
  "projectOrder.numberOfSets": "Number of sets",
  "projectOrder.projectBatchInformation": "Project batch information",
  "projectOrder.factoryPlanned": "Factory Planned Delivery Date",
  "projectOrder.administrativeDivision": "administrative division",
  "projectOrder.placeOrderNot": "place order or not",
  "projectOrder.FlyerTime": "Flyer time",
  "projectOrder.specificAddress": "Specific address",
  "projectOrder.otherAttachments": "Other attachments",
  "projectOrder.counterTopAttachments": "Countertop attachments",
  "projectOrder.priceAttachments": "Price attachments",
  "projectOrder.uploadAttachments": "Upload attachments",
  "projectOrder.counterTop": "Countertop",
  "projectOrder.selectAll": "Select all",
  "projectOrder.startDate": "Start date",
  "projectOrder.endDate": "End date",
  "projectOrder.to": "to",
  "projectOrder.selectBrand": "Please select brand",
  "projectOrder.selectCategory": "Please select category",
  "projectOrder.transferred": "Transferred to",
  "projectOrder.clickTransferred": "Click to transfer to",
  "projectOrder.oderUpdateTime": "Order update time",
  "projectOrder.noDataAvailable": "There is currently no data available",
  "projectOrder.loadingDesperately": "Loading desperately",
  "projectOrder.orderUpdateTime":
    "Please confirm that the selected order is the latest order information based on the order update time",
  "projectOrder.successfullyPlaced": "Successfully placed an order",
  "projectOrder.defaultOrderType":
    "PTD-WMD-10-30-Foreign trade orders-Ordinary orders",
  "projectOrder.defaultOrderTypeGcd":
  "PTD-GCD-10-20-Engineering orders-Ordinary orders",
  "projectOrder.enter": "Enter",
  "projectOrder.designerPhoneEmpty": "Designer phone cannot be empty",
  "projectOrder.designerEmpty": "Designer cannot be empty",
  "projectOrder.selectDate": "Select Date",
  "projectOrder.modifyingSpace":
    "After modifying the space product name, the existing order cannot be overwritten. Please confirm if the order has been uploaded to avoid duplicate orders",
  "projectOrder.coverTabletop":
    "The tabletop drawings uploaded this time will cover the tabletop drawings in the attachment of the design software disassembly order. Please confirm whether to replace them?",

  "projectOrder.oppein": "OPPEIN",
  "projectOrder.outu": "Outu",
  "projectOrder.oboli": "OPPLIA",
  "projectOrder.oboni": "OPLONI",
  "projectOrder.owell": "OWELL",
  "projectOrder.baunis": "Baunis",
  "projectOrder.starhomes": "STARHOMES",
  "projectOrder.oboladi": "Oboladi",
  "projectOrder.fitzcarl": "Fitzcarl",
  "projectOrder.baunisStarhomes": "Baunis",
  "projectOrder.miform": "Miform",
  "projectOrder.oppeinZhina": "ZN",

  "projectOrder.youcai": "Excellent materials",
  "projectOrder.zhuangxiu": "Decoration materials",
  "projectOrder.zhucaijicheng": "Main material integration",
  "projectOrder.zhuangjiamen": "Armored door",
  "projectOrder.bancai": "Board",
  "projectOrder.shangchu": "Commercial cabinet",
  "projectOrder.jinshumenchuang": "Metal doors and windows",
  "projectOrder.dajiaju": "Whole house",
  "projectOrder.qiangshi": "Soft decoration",
  "projectOrder.mumen": "Wooden door",
  "projectOrder.zhinengjiaju": "Smart home",
  "projectOrder.weiyu": "Vanity",
  "projectOrder.obbao": "奥铂",
  "projectOrder.owell": "奥维",

  "projectOrder.wardrobe": "Wardrobe",
  "projectOrder.cabinet": "Cabinet",
  "projectOrder.queuing": "queuing",
  "projectOrder.splittingOrders": "In the process of splitting orders",
  "projectOrder.successfullySplit": "Successfully split the order",
  "projectOrder.splitOrderFailed": "Split order failed",
  "projectOrder.cancelSplit": "Cancel split order",
  "projectOrder.simpleOrder": "Simple order splitting",
  "projectOrder.fullOrder": "Full order splitting",
  "projectOrder.taskStatus": "Please select the task status",
  "projectOrder.taskType": "Please select a task type",
  "projectOrder.splitRecord":
    "Please select the split record that needs to be exported!",
  "projectOrder.splitNoFiles":
    "No files have been successfully split, please confirm!",
  "projectOrder.cancelSplitSuccess": "Successfully cancelled the split order",
  "projectOrder.selectPersonnel": "Please select personnel",
  "projectOrder.notCreated": "Not created",
  "projectOrder.creating": "Creating",
  "projectOrder.createdSuccessfully": "Created successfully",
  "projectOrder.creationFailed": "Creation failed",
  "projectOrder.designFileProcessing": "Design file processing",
  "projectOrder.successfullyDesignFiles": "Successfully processed design files",
  "projectOrder.designFileFailed": "Design file processing failed",
  "projectOrder.draftSaved": "Draft saved",
  "projectOrder.readingScheme": "Reading scheme content",
  "projectOrder.uploadSuccessful": "Upload successful",
  "projectOrder.batchSetBrand":
    "Batch set product categories for the same brand category",
  "projectOrder.enoppein": "OPPEIN",
  "projectOrder.importCompleted": "Import completed",
  "projectOrder.exporting": "Exporting, please wait...",
  "projectOrder.deleteTask":
    "Are you sure to delete the order task? The task record is not visible after deletion",
  "projectOrder.successfullyDeleted": "Successfully deleted",
  "projectOrder.confirmation": "Confirmation",
  "projectOrder.useCaxaTabletop":
    "Please choose the reason not to use CAXA tabletop diagram",
  "projectOrder.successfullyDeleted": "Successfully deleted",
  "projectOrder.deleteOrder": "Are you sure to delete the order ?",
  "projectOrder.makeSureStandard":
    "Modifying the brand, category, and product channel will clear the standard products. Please confirm if you want to continue with the modification?",
};



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/projectOrder/settings.js